<i18n
  src="@/locales/views/packing_house/quality_control/process/list_templates.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/quality_template.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ph_quality_control_process_list_harvested_batches_path"
    :params="{
      packing_house_id: packing_house_id,
      packing_house_process_id: packing_house_process_id,
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[
      module_name,
      agro_exporter_process.name,
      harvested_batch?.batch_code,
    ]"
  ></bread-crumbs>
  <template v-if="render_page">
    <harvested-batch-info
      v-if="harvested_batch"
      :harvested_batch="harvested_batch"
    />

    <h1 class="page-title mt-8">
      <i class="fa-solid fa-box-check"></i><span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>

    <div class="mt-8 flex flex-col">
      <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <ul role="list" class="divide-y divide-slate-200">
          <li
            v-for="template in exporter_process_quality_template"
            :key="template.id"
          >
            <div
              href="#"
              class="block hover:bg-slate-50 cursor-pointer"
              @click="goToListQualityInspects(template)"
            >
              <div class="px-4 py-4 sm:px-6">
                <div class="flex items-center justify-between">
                  <p class="text-sm font-medium text-gray-900 truncate">
                    {{ template.quality_template.name }}
                  </p>
                  <div class="ml-2 flex-shrink-0 flex">
                    <a class="link" @click="goToListQualityInspects(template)">
                      <i class="fa-solid fa-pen"></i>
                      <span class="space-icon"></span>
                      {{ $t("labels.manage_link") }}
                    </a>
                  </div>
                </div>

                <div class="mt-2 sm:flex sm:justify-between">
                  <div class="sm:flex">
                    <p
                      class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0"
                    >
                      <i
                        class="fa-solid fa-box-check flex-shrink-0"
                        aria-hidden="true"
                      />
                      <span class="space-icon"></span>
                      {{ template.num_quality_inspects }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </template>
  <loading-message v-else />
  <div></div>
</template>

<script>
import Requester from "@/views/packing_house/requesters/quality_control/process/list_templates.js";
import HarvestedBatchInfo from "@/components/views/packing_house/quality_control/process/HarvestedBatchInfo.vue";
export default {
  components: { HarvestedBatchInfo },
  name: "ListTemplates",

  props: ["packing_house_id", "packing_house_process_id", "harvested_batch_id"],
  data() {
    return {
      agro_exporter_process: {},
      harvested_batch: null,
      exporter_process_quality_template: [],
      render_harvest: false,
      render_list: false,
    };
  },
  computed: {
    render_page: function () {
      return this.render_harvest && this.render_list;
    },
  },
  methods: {
    fetchPackingHouseProcess: async function () {
      let response = await Requester.fetchPackingHouseProcess({
        packing_house_id: this.packing_house_id,
        packing_house_process_id: this.packing_house_process_id,
        harvested_batch_id: this.harvested_batch_id,
      });
      this.agro_exporter_process = response.data;
    },
    fetchHarvestedBatch: async function () {
      let response = await Requester.fetchHarvestedBatch({
        packing_house_id: this.packing_house_id,
        packing_house_process_id: this.packing_house_process_id,
        harvested_batch_id: this.harvested_batch_id,
      });
      this.harvested_batch = response.data;
      this.render_harvest = true;
    },
    fetchTemplates: async function () {
      let response = await Requester.fetchTemplates({
        packing_house_id: this.packing_house_id,
        packing_house_process_id: this.packing_house_process_id,
        harvested_batch_id: this.harvested_batch_id,
      });
      this.exporter_process_quality_template = response.data;
      this.render_list = true;
    },
    goToListQualityInspects: function (template) {
      this.$router.push({
        name: "ph_quality_control_process_list_inspects_path",
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          harvested_batch_id: this.harvested_batch_id,
          packing_process_quality_template_id: template.id,
        },
      });
    },
    goToTemplateGraph: function (exporter_process_quality_template) {
      this.$router.push({
        name: "ae_quality_control_container_containers_inspect_graphs_path",
        params: {
          packing_house_process_id: this.packing_house_process_id,
          exporter_process_quality_template_id:
            exporter_process_quality_template.id,
        },
      });
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id,
        },
      }).then(() => {
        this.checkIfAuthenticated();
        this.fetchPackingHouseProcess();
        this.fetchHarvestedBatch();
        this.fetchTemplates();
      })
    );
  },
};
</script>
